import Vue from "vue";

import VueResource from "vue-resource";

import amplitude from "amplitude-js";

Vue.use(VueResource);

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

import "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
// import '@babel/polyfill'
import App from "./App.vue";
import i18n from "@/i18n";

import MultiFiltersPlugin from "./plugins/MultiFilters"; // <-- THIS
Vue.use(MultiFiltersPlugin); // <-- THIS

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VImageInput from "vuetify-image-input";
Vue.component(VImageInput.name, VImageInput);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Swal from "sweetalert2/dist/sweetalert2.js";
Vue.use(VueSweetalert2);

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 10000,
  timerProgressBar: true,
});

window.Toast = Toast;

import axios from "axios";
import router from "@/router";
import { firebaseApp } from "./firebase/firebase";
import { firebaseAuth } from "./firebase/firebaseAuth";

import store from "@/store";
import { createProvider } from "./vue-apollo";
import "./utils/filters";
import api from "./utils/api";

import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);

// Sync store with router
sync(store, router);

Vue.$http = api;
api.defaults.timeout = 15000;
api.defaults.headers.get["Accepts"] = "application/json";
api.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      let idToken = token;

      config.headers.common["Authorization"] = "Bearer " + (await idToken);
      config.headers.common["x-client-system"] = "super";
    }
    return config;
  },
  (error) => {
    console.error("error: ", error);
    return Promise.reject(error);
  },
);
let loop = 0;
let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed(token) {
  subscribers.map((cb) => cb(token));
}

api.interceptors.response.use(
  (response) => response,
  (err) => {
    const originalRequest = err.config;
    console.log("Error interceptior Response: ", err);
    if (
      (err &&
        err.response &&
        err.response.status === 400 &&
        err.response.data &&
        err.response.data.code === "auth/id-token-expired" &&
        loop < 1) ||
      err.response.status === 403
    ) {
      loop++;
      if (!isRefreshing) {
        isRefreshing = true;
        firebaseAuth.currentUser.getIdToken(true).then((idToken) => {
          const now = new Date();
          //Configura o logout para daqui 2 horas
          const expirationDate = new Date(now.getTime() + 7200000);
          localStorage.setItem("token", idToken);
          localStorage.setItem("expirationDate", expirationDate);
          isRefreshing = false;
          onRrefreshed(idToken);
          subscribers = [];
        });
      }

      return new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          resolve(axios(originalRequest));
        });
      });
    }
    return Promise.reject(err);
  },
);

axios.defaults.headers.get["Accepts"] = "application/json";
axios.defaults.baseURL = process.env.VUE_APP_USER_API_BASE;
axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

Vue.config.productionTip = false;

let app = "";

export const eventBus = new Vue();

amplitude.getInstance().init("2982662131ffc5fdca61e62aa7b80ec2", null, {
  // optional configuration options
  saveEvents: true,
  includeUtm: true,
  includeReferrer: true,
  trackingOptions: {
    city: true,
    ip_address: true,
  },
});

firebaseApp.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      store,
      apolloProvider: createProvider(),
      render: (h) => h(App),
    }).$mount("#app");
  }
});
